<template>
  <div>
    <v-dialog v-model="selectCustomerDialog" max-width="600">
      <v-card>
        <v-card-title>{{header}}</v-card-title>
        <v-card-text class="py-5">
          <p>{{ $t('customer.search_by_name_surname_phone_citizen_id_email') }}</p>
          <SelectCustomerInput
            v-if="selectCustomerDialog"
            v-model="customer"
            :placeholder="$t('search')"
            prepend-inner-icon="mdi-database-search"
            background-color="grey lighten-4"
            @onSelect="d => customer = d"
          />
          <template v-if="customer">
            <template v-if="!customer.addCustomer">
              <div class="p-3 shadow-md flex">
                <img
                  v-if="customer.profileImages"
                  style="height:150px;width:auto;object-fit: contain;border-radius: 5px;"
                  :src="customer.profileImages[0]? customer.profileImages[0].url : '/user.png'"
                />
                <div class="w-100">
                  <div class="text-right">
                    <v-btn
                      color="warning"
                      text
                      @click="changeProfile(customer.objectId)"
                      :loading="isProfileLoading"
                      :disabled="!checkPermission()"
                    >
                      <v-icon left>mdi-pencil</v-icon>{{ $t('account.edit_profile') }}
                    </v-btn>
                  </div>
                  <div style="padding:0px 20px;">
                    <h4 class="mb-2">{{ customer.fullNameNoTitle }}</h4>
                    <div>{{ $t('account.phone_number') }} : {{ customer.fullTels }}</div>
                    <div>{{ $t('account.email') }} : {{ customer.fullEmails }}</div>
                    <div>{{ $t('tax.citizen_id_or_tax_id') }} : {{ customer.citizenId }}</div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            elevation="0"
            @click="$emit('select', customer)"
            :disabled="!customer || customer == null"
            :loading="isLoading || isMainLoading"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('ok') }}
          </v-btn>
          <v-btn color="error" elevation="0" @click="selectCustomerDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <form-customer
      :event="customerEvent"
      v-model="addCustomer"
      :objectId="customerObj.objectId"
      @onUpdated="changeProfileOutput"
    ></form-customer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerSelect from "./CustomerSelect.vue";
import FormCustomer from "./FormCustomer.vue";
import SelectCustomerInput from "./SelectCustomerInput.vue";
export default {
  components: { 
    FormCustomer,
    CustomerSelect,
    SelectCustomerInput
  },
  name: "SelectCustomer",
  props: {
    value: Boolean,
    isMainLoading: Boolean,
    header: {
      type: String,
      default: ""
    }
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    selectCustomerDialog: {
      get() {
        if (this.value) {
          this.customer = null;
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      customer: null,
      isLoading: false,
      addCustomer: false,
      customerEvent: "create",
      customerObj: {},
      isProfileLoading: false,
      isSelectedCustomer: "personal",
      internalHeader: ""
    };
  },
  created() {
    this.internalHeader = this.header || this.$t('customer.select_contractor');
  },
  methods: {
    changeProfileOutput(val) {
      this.customer = Object.assign({}, val);
    },
    async changeProfile(objectId) {
      this.customerEvent = "edit";
      this.isProfileLoading = true;
      await this.$store.dispatch("customer/getCustomer", { id: objectId });
      this.isProfileLoading = false;
      this.customerObj = this.$store.getters["customer/getCustomer"];
      this.addCustomer = true;
    },
    checkPermission() {
      let res = false;
      if (this.admin) {
        res = true;
      } else if (this.employee && this.employee.enableViewCustomers) {
        res = true;
      } else {
        res = false;
      }
      return res;
    },
  }
};
</script>
